import { jamezzApplicationType } from "../../../qr/App";

export default function isQr() {
  return jamezzApplicationType.type === "QR";
}
